import { render, staticRenderFns } from "./topbar-language.vue?vue&type=template&id=d62f8c10"
import script from "./topbar-language.vue?vue&type=script&lang=js"
export * from "./topbar-language.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/topbar/topbar-language.vue
// module id = Ck0Q
// module chunks = 0